export default () => ({
  device: null,
  devices: [],
  totalDevices: 0,
  connectedDevices: [],
  serverProfiles: [],
  pairingInfo: null,
  pairingInfoWorkOrder: null,
  currentDevice: null,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Name',
  status: '',
  filterBy: 0
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/devices/state.js